
export const aboutTranslations = {
  en: {
    about: {
      title: 'About Finanzly',
      subtitle: 'Empowering you to make smarter financial decisions through innovative tools and technology.',
      hero: {
        badge: 'Building the future of finance',
        title: 'We Democratize Access to Financial Tools',
        subtitle: 'Powerful financial calculators and AI-powered tools that help you make smarter decisions about your money.',
        cta: 'Explore Tools',
        contact: 'Contact Us'
      },
      stats: {
        users: 'Active Users',
        calculations: 'Calculations Made',
        tools: 'Financial Tools',
        uptime: 'Uptime'
      },
      team: {
        badge: 'The Team',
        title: 'Meet Our Team',
        subtitle: 'We are two passionate engineers committed to making personal finance accessible to everyone.',
        roberto_ruiz: {
          name: 'Roberto Ruiz Sánchez',
          role: 'Co-founder & AI Engineer',
          description: 'Artificial Intelligence and Data Scientist Engineer. Developing Deep Learning models for industrial processes. Specialized in NLP, conversational agents and scalable cloud infrastructures.',
          skills: ['Python', 'Deep Learning', 'Data Science', 'Machine Learning', 'AWS', 'Azure']
        },
        roberto_otero: {
          name: 'Roberto Otero Galán',
          role: 'Co-founder & Software Engineer',
          description: 'Software Engineer with experience in backend development with Java, Spring Boot and microservices architecture. Passionate about cybersecurity, Machine Learning and intelligent process automation.',
          skills: ['Java', 'Spring Boot', 'Python', 'AI', 'Docker', 'Cybersecurity']
        }
      },
      mission: {
        badge: 'Our Mission',
        title: 'Making Finance Accessible to Everyone',
        description: 'At Finanzly, we believe that everyone deserves access to powerful financial tools that can help them build a better future. We\'re committed to making financial management more accessible, intuitive, and effective for everyone.',
        details: 'In today\'s rapidly evolving financial landscape, we understand that managing personal finances can be overwhelming. That\'s why we\'ve created intuitive tools that simplify complex financial calculations and help you make informed decisions about your money.',
        highlight: {
          title: 'Our Commitment',
          subtitle: 'What drives us every day'
        },
        point1: 'Free access to essential financial tools',
        point2: 'Privacy-first approach with no data selling',
        point3: 'Continuous improvement based on user feedback'
      },
      values: {
        title: 'Our Values',
        subtitle: 'The principles that guide everything we do at Finanzly',
        transparency: {
          title: 'Transparency',
          description: 'We believe in clear, honest communication. No hidden fees, no confusing terms, just straightforward financial tools.'
        },
        simplicity: {
          title: 'Simplicity',
          description: 'Complex financial concepts made simple. Our tools are designed to be intuitive and easy to use for everyone.'
        },
        accessibility: {
          title: 'Accessibility',
          description: 'Financial tools should be available to everyone, regardless of their background or expertise level.'
        },
        innovation: {
          title: 'Innovation',
          description: 'We constantly push boundaries to bring you the latest in fintech, including AI-powered financial assistance.'
        }
      },
      tools: {
        title: 'Our Financial Tools',
        description: 'Powerful calculators designed to help you make better financial decisions',
        comingSoon: 'Coming Soon',
        available: 'Available Now',
        tryAssistant: 'Try Assistant',
        viewAll: 'View All Tools'
      },
      future: {
        badge: 'Innovation',
        title: 'AI-Powered Financial Planning',
        description: 'We leverage cutting-edge artificial intelligence to provide you with personalized financial guidance. Our AI assistant is designed to help you navigate complex financial decisions with confidence.',
        aiTitle: 'AI Financial Assistant',
        aiShort: 'Your personal AI advisor for smarter financial decisions',
        aiDescription: 'Our AI-powered financial assistant helps you make smarter financial decisions, provides personalized advice, and helps you optimize your financial strategy based on your unique situation and goals.',
        aiDetails: 'Our AI assistant will leverage advanced machine learning algorithms to analyze your financial patterns, provide personalized recommendations, and help you optimize your investment strategy.',
        feature1: 'Personalized financial advice based on your goals',
        feature2: 'Smart spending analysis and recommendations',
        feature3: 'Investment portfolio optimization suggestions',
        feature4: 'Real-time market insights and alerts'
      },
      cta: {
        title: 'Ready to Take Control of Your Finances?',
        subtitle: 'Start using our free tools today and make smarter financial decisions.',
        button: 'Get Started Free'
      },
      skills: {
        python: 'Python',
        deepLearning: 'Deep Learning',
        dataScience: 'Data Science',
        machineLearning: 'Machine Learning',
        aws: 'AWS',
        azure: 'Azure',
        java: 'Java',
        ai: 'AI',
        docker: 'Docker',
        cybersecurity: 'Cybersecurity'
      }
    }
  },
  es: {
    about: {
      title: 'Acerca de Finanzly',
      subtitle: 'Capacitándote para tomar decisiones financieras más inteligentes a través de herramientas e innovación tecnológica.',
      hero: {
        badge: 'Construyendo el futuro de las finanzas',
        title: 'Democratizamos el Acceso a Herramientas Financieras',
        subtitle: 'Calculadoras financieras potentes y herramientas impulsadas por IA que te ayudan a tomar decisiones más inteligentes sobre tu dinero.',
        cta: 'Explorar Herramientas',
        contact: 'Contáctanos'
      },
      stats: {
        users: 'Usuarios Activos',
        calculations: 'Cálculos Realizados',
        tools: 'Herramientas Financieras',
        uptime: 'Disponibilidad'
      },
      team: {
        badge: 'El Equipo',
        title: 'Conoce a Nuestro Equipo',
        subtitle: 'Somos dos ingenieros apasionados comprometidos con hacer las finanzas personales accesibles para todos.',
        roberto_ruiz: {
          name: 'Roberto Ruiz Sánchez',
          role: 'Co-fundador & Ingeniero en IA',
          description: 'Ingeniero en Inteligencia Artificial y Data Scientist. Desarrollo modelos de Deep Learning y Aprendizaje profundo para procesos industriales. Especializado en NLP, agentes conversacionales e infraestructuras cloud escalables.',
          skills: ['Python', 'Deep Learning', 'Data Science', 'Machine Learning', 'AWS', 'Azure']
        },
        roberto_otero: {
          name: 'Roberto Otero Galán',
          role: 'Co-fundador & Ingeniero de Software',
          description: 'Ingeniero de Software con experiencia en desarrollo backend en Java, Spring Boot y arquitectura de microservicios. Apasionado por la seguridad informática, el Machine Learning y la automatización inteligente de procesos.',
          skills: ['Java', 'Spring Boot', 'Python', 'IA', 'Docker', 'Ciberseguridad']
        }
      },
      mission: {
        badge: 'Nuestra Misión',
        title: 'Haciendo las Finanzas Accesibles para Todos',
        description: 'En Finanzly, creemos que todos merecen acceso a herramientas financieras poderosas que puedan ayudarles a construir un mejor futuro. Estamos comprometidos a hacer que la gestión financiera sea más accesible, intuitiva y efectiva para todos.',
        details: 'En el panorama financiero actual en rápida evolución, entendemos que gestionar las finanzas personales puede ser abrumador. Por eso hemos creado herramientas intuitivas que simplifican los cálculos financieros complejos y te ayudan a tomar decisiones informadas sobre tu dinero.',
        highlight: {
          title: 'Nuestro Compromiso',
          subtitle: 'Lo que nos impulsa cada día'
        },
        point1: 'Acceso gratuito a herramientas financieras esenciales',
        point2: 'Enfoque de privacidad primero, sin venta de datos',
        point3: 'Mejora continua basada en feedback de usuarios'
      },
      values: {
        title: 'Nuestros Valores',
        subtitle: 'Los principios que guían todo lo que hacemos en Finanzly',
        transparency: {
          title: 'Transparencia',
          description: 'Creemos en una comunicación clara y honesta. Sin tarifas ocultas, sin términos confusos, solo herramientas financieras directas.'
        },
        simplicity: {
          title: 'Simplicidad',
          description: 'Conceptos financieros complejos hechos simples. Nuestras herramientas están diseñadas para ser intuitivas y fáciles de usar.'
        },
        accessibility: {
          title: 'Accesibilidad',
          description: 'Las herramientas financieras deben estar disponibles para todos, independientemente de su experiencia o conocimientos.'
        },
        innovation: {
          title: 'Innovación',
          description: 'Constantemente superamos límites para traerte lo último en fintech, incluyendo asistencia financiera con IA.'
        }
      },
      tools: {
        title: 'Nuestras Herramientas Financieras',
        description: 'Calculadoras potentes diseñadas para ayudarte a tomar mejores decisiones financieras',
        comingSoon: 'Próximamente',
        available: 'Disponible',
        tryAssistant: 'Probar Asistente',
        viewAll: 'Ver Todas las Herramientas'
      },
      future: {
        badge: 'Innovación',
        title: 'Planificación Financiera con IA',
        description: 'Aprovechamos la inteligencia artificial de vanguardia para brindarte orientación financiera personalizada. Nuestro asistente de IA está diseñado para ayudarte a navegar decisiones financieras complejas con confianza.',
        aiTitle: 'Asistente Financiero IA',
        aiShort: 'Tu asesor personal de IA para decisiones financieras más inteligentes',
        aiDescription: 'Nuestro asistente financiero potenciado por IA te ayuda a tomar decisiones financieras más inteligentes, proporciona consejos personalizados y te ayuda a optimizar tu estrategia financiera basada en tu situación y objetivos únicos.',
        aiDetails: 'Nuestro asistente de IA utilizará algoritmos avanzados de aprendizaje automático para analizar tus patrones financieros y proporcionar recomendaciones personalizadas.',
        feature1: 'Consejos financieros personalizados según tus objetivos',
        feature2: 'Análisis inteligente de gastos y recomendaciones',
        feature3: 'Sugerencias de optimización de cartera de inversión',
        feature4: 'Alertas e información del mercado en tiempo real'
      },
      cta: {
        title: '¿Listo para Tomar Control de tus Finanzas?',
        subtitle: 'Comienza a usar nuestras herramientas gratuitas hoy y toma decisiones financieras más inteligentes.',
        button: 'Comenzar Gratis'
      },
      skills: {
        python: 'Python',
        deepLearning: 'Deep Learning',
        dataScience: 'Data Science',
        machineLearning: 'Machine Learning',
        aws: 'AWS',
        azure: 'Azure',
        java: 'Java',
        ai: 'IA',
        docker: 'Docker',
        cybersecurity: 'Ciberseguridad'
      }
    }
  },
  de: {
    about: {
      title: 'Über Finanzly',
      subtitle: 'Wir ermöglichen Ihnen, durch innovative Tools und Technologie klügere finanzielle Entscheidungen zu treffen.',
      hero: {
        badge: 'Die Zukunft der Finanzen gestalten',
        title: 'Wir Demokratisieren den Zugang zu Finanztools',
        subtitle: 'Leistungsstarke Finanzrechner und KI-gestützte Tools, die Ihnen helfen, klügere Entscheidungen über Ihr Geld zu treffen.',
        cta: 'Tools Entdecken',
        contact: 'Kontakt'
      },
      stats: {
        users: 'Aktive Nutzer',
        calculations: 'Durchgeführte Berechnungen',
        tools: 'Finanztools',
        uptime: 'Verfügbarkeit'
      },
      team: {
        badge: 'Das Team',
        title: 'Lernen Sie Unser Team Kennen',
        subtitle: 'Wir sind zwei leidenschaftliche Ingenieure, die sich dafür einsetzen, persönliche Finanzen für alle zugänglich zu machen.',
        roberto_ruiz: {
          name: 'Roberto Ruiz Sánchez',
          role: 'Mitgründer & KI-Ingenieur',
          description: 'Ingenieur für Künstliche Intelligenz und Data Scientist. Entwicklung von Deep Learning Modellen für industrielle Prozesse. Spezialisiert auf NLP, Konversationsagenten und skalierbare Cloud-Infrastrukturen.',
          skills: ['Python', 'Deep Learning', 'Data Science', 'Machine Learning', 'AWS', 'Azure']
        },
        roberto_otero: {
          name: 'Roberto Otero Galán',
          role: 'Mitgründer & Software-Ingenieur',
          description: 'Software-Ingenieur mit Erfahrung in Backend-Entwicklung mit Java, Spring Boot und Microservices-Architektur. Leidenschaftlich für Cybersicherheit, Machine Learning und intelligente Prozessautomatisierung.',
          skills: ['Java', 'Spring Boot', 'Python', 'KI', 'Docker', 'Cybersicherheit']
        }
      },
      mission: {
        badge: 'Unsere Mission',
        title: 'Finanzen für Alle Zugänglich Machen',
        description: 'Bei Finanzly glauben wir, dass jeder Zugang zu leistungsstarken Finanztools haben sollte, die beim Aufbau einer besseren Zukunft helfen können.',
        details: 'In der sich schnell entwickelnden Finanzlandschaft von heute verstehen wir, dass die Verwaltung persönlicher Finanzen überwältigend sein kann. Deshalb haben wir intuitive Tools entwickelt, die komplexe Finanzberechnungen vereinfachen.',
        highlight: {
          title: 'Unser Versprechen',
          subtitle: 'Was uns jeden Tag antreibt'
        },
        point1: 'Kostenloser Zugang zu essentiellen Finanztools',
        point2: 'Datenschutz an erster Stelle, kein Datenverkauf',
        point3: 'Kontinuierliche Verbesserung basierend auf Nutzerfeedback'
      },
      values: {
        title: 'Unsere Werte',
        subtitle: 'Die Prinzipien, die alles leiten, was wir bei Finanzly tun',
        transparency: {
          title: 'Transparenz',
          description: 'Wir glauben an klare, ehrliche Kommunikation. Keine versteckten Gebühren, keine verwirrenden Begriffe.'
        },
        simplicity: {
          title: 'Einfachheit',
          description: 'Komplexe Finanzkonzepte einfach gemacht. Unsere Tools sind intuitiv und einfach zu bedienen.'
        },
        accessibility: {
          title: 'Zugänglichkeit',
          description: 'Finanztools sollten für alle verfügbar sein, unabhängig von Hintergrund oder Erfahrung.'
        },
        innovation: {
          title: 'Innovation',
          description: 'Wir überschreiten ständig Grenzen, um Ihnen das Neueste in Fintech zu bieten.'
        }
      },
      tools: {
        title: 'Unsere Finanztools',
        description: 'Leistungsstarke Rechner, die Ihnen helfen, bessere finanzielle Entscheidungen zu treffen',
        comingSoon: 'Demnächst',
        available: 'Verfügbar',
        tryAssistant: 'Assistent Testen',
        viewAll: 'Alle Tools Anzeigen'
      },
      future: {
        badge: 'Innovation',
        title: 'KI-gestützte Finanzplanung',
        description: 'Wir nutzen modernste künstliche Intelligenz, um Ihnen personalisierte Finanzberatung zu bieten. Unser KI-Assistent hilft Ihnen, komplexe Finanzentscheidungen mit Zuversicht zu treffen.',
        aiTitle: 'KI-Finanzassistent',
        aiShort: 'Ihr persönlicher KI-Berater für klügere Finanzentscheidungen',
        aiDescription: 'Unser KI-gestützter Finanzassistent hilft Ihnen, intelligentere Finanzentscheidungen zu treffen, bietet personalisierte Beratung und optimiert Ihre Finanzstrategie.',
        aiDetails: 'Unser KI-Assistent wird fortschrittliche Machine-Learning-Algorithmen nutzen, um Ihre Finanzmuster zu analysieren.',
        feature1: 'Personalisierte Finanzberatung basierend auf Ihren Zielen',
        feature2: 'Intelligente Ausgabenanalyse und Empfehlungen',
        feature3: 'Vorschläge zur Portfoliooptimierung',
        feature4: 'Echtzeit-Markteinblicke und Benachrichtigungen'
      },
      cta: {
        title: 'Bereit, die Kontrolle über Ihre Finanzen zu Übernehmen?',
        subtitle: 'Nutzen Sie noch heute unsere kostenlosen Tools und treffen Sie klügere Finanzentscheidungen.',
        button: 'Kostenlos Starten'
      },
      skills: {
        python: 'Python',
        deepLearning: 'Deep Learning',
        dataScience: 'Data Science',
        machineLearning: 'Machine Learning',
        aws: 'AWS',
        azure: 'Azure',
        java: 'Java',
        ai: 'KI',
        docker: 'Docker',
        cybersecurity: 'Cybersicherheit'
      }
    }
  },
  fr: {
    about: {
      title: "À Propos de Finanzly",
      subtitle: "Vous permettre de prendre des décisions financières plus intelligentes grâce à des outils et technologies innovantes.",
      hero: {
        badge: "Construire l'avenir de la finance",
        title: "Nous Démocratisons l'Accès aux Outils Financiers",
        subtitle: "Des calculatrices financières puissantes et des outils alimentés par l'IA pour vous aider à prendre des décisions plus intelligentes.",
        cta: "Explorer les Outils",
        contact: "Nous Contacter"
      },
      stats: {
        users: "Utilisateurs Actifs",
        calculations: "Calculs Effectués",
        tools: "Outils Financiers",
        uptime: "Disponibilité"
      },
      team: {
        badge: "L'Équipe",
        title: "Rencontrez Notre Équipe",
        subtitle: "Nous sommes deux ingénieurs passionnés engagés à rendre les finances personnelles accessibles à tous.",
        roberto_ruiz: {
          name: "Roberto Ruiz Sánchez",
          role: "Co-fondateur & Ingénieur IA",
          description: "Ingénieur en Intelligence Artificielle et Data Scientist. Développement de modèles de Deep Learning pour les processus industriels. Spécialisé en NLP, agents conversationnels et infrastructures cloud évolutives.",
          skills: ["Python", "Deep Learning", "Data Science", "Machine Learning", "AWS", "Azure"]
        },
        roberto_otero: {
          name: "Roberto Otero Galán",
          role: "Co-fondateur & Ingénieur Logiciel",
          description: "Ingénieur Logiciel avec expérience en développement backend avec Java, Spring Boot et architecture microservices. Passionné par la cybersécurité, le Machine Learning et l'automatisation intelligente.",
          skills: ["Java", "Spring Boot", "Python", "IA", "Docker", "Cybersécurité"]
        }
      },
      mission: {
        badge: "Notre Mission",
        title: "Rendre la Finance Accessible à Tous",
        description: "Chez Finanzly, nous croyons que chacun mérite d'avoir accès à des outils financiers puissants qui peuvent les aider à construire un meilleur avenir.",
        details: "Dans le paysage financier en rapide évolution d'aujourd'hui, nous comprenons que la gestion des finances personnelles peut être accablante. C'est pourquoi nous avons créé des outils intuitifs.",
        highlight: {
          title: "Notre Engagement",
          subtitle: "Ce qui nous motive chaque jour"
        },
        point1: "Accès gratuit aux outils financiers essentiels",
        point2: "Approche axée sur la confidentialité, sans vente de données",
        point3: "Amélioration continue basée sur les retours utilisateurs"
      },
      values: {
        title: "Nos Valeurs",
        subtitle: "Les principes qui guident tout ce que nous faisons chez Finanzly",
        transparency: {
          title: "Transparence",
          description: "Nous croyons en une communication claire et honnête. Pas de frais cachés, pas de termes confus."
        },
        simplicity: {
          title: "Simplicité",
          description: "Des concepts financiers complexes rendus simples. Nos outils sont conçus pour être intuitifs."
        },
        accessibility: {
          title: "Accessibilité",
          description: "Les outils financiers devraient être disponibles pour tous, quel que soit leur niveau d'expertise."
        },
        innovation: {
          title: "Innovation",
          description: "Nous repoussons constamment les limites pour vous apporter les dernières innovations en fintech."
        }
      },
      tools: {
        title: "Nos Outils Financiers",
        description: "Des calculatrices puissantes conçues pour vous aider à prendre de meilleures décisions financières",
        comingSoon: "Bientôt",
        available: "Disponible",
        tryAssistant: "Essayer l'Assistant",
        viewAll: "Voir Tous les Outils"
      },
      future: {
        badge: "Innovation",
        title: "Planification Financière Alimentée par l'IA",
        description: "Nous utilisons l'intelligence artificielle de pointe pour vous fournir des conseils financiers personnalisés. Notre assistant IA est conçu pour vous aider à naviguer dans des décisions financières complexes en toute confiance.",
        aiTitle: "Assistant Financier IA",
        aiShort: "Votre conseiller IA personnel pour des décisions financières plus intelligentes",
        aiDescription: "Notre assistant financier alimenté par l'IA vous aide à prendre des décisions financières plus intelligentes, fournit des conseils personnalisés et optimise votre stratégie financière.",
        aiDetails: "Notre assistant IA utilisera des algorithmes avancés d'apprentissage automatique pour analyser vos habitudes financières.",
        feature1: "Conseils financiers personnalisés selon vos objectifs",
        feature2: "Analyse intelligente des dépenses et recommandations",
        feature3: "Suggestions d'optimisation de portefeuille d'investissement",
        feature4: "Aperçus du marché en temps réel et alertes"
      },
      cta: {
        title: "Prêt à Prendre le Contrôle de Vos Finances?",
        subtitle: "Commencez à utiliser nos outils gratuits aujourd'hui et prenez des décisions financières plus intelligentes.",
        button: "Commencer Gratuitement"
      },
      skills: {
        python: 'Python',
        deepLearning: 'Deep Learning',
        dataScience: 'Science des Données',
        machineLearning: 'Machine Learning',
        aws: 'AWS',
        azure: 'Azure',
        java: 'Java',
        ai: 'IA',
        docker: 'Docker',
        cybersecurity: 'Cybersécurité'
      }
    }
  },
  hi: {
    about: {
      title: "Finanzly के बारे में",
      subtitle: "नवीन उपकरणों और प्रौद्योगिकी के माध्यम से आपको बेहतर वित्तीय निर्णय लेने के लिए सशक्त बनाना।",
      hero: {
        badge: "वित्त का भविष्य बना रहे हैं",
        title: "हम वित्तीय उपकरणों तक पहुंच को लोकतांत्रिक बनाते हैं",
        subtitle: "शक्तिशाली वित्तीय कैलकुलेटर और AI-संचालित उपकरण जो आपको अपने पैसे के बारे में बेहतर निर्णय लेने में मदद करते हैं।",
        cta: "उपकरण देखें",
        contact: "संपर्क करें"
      },
      stats: {
        users: "सक्रिय उपयोगकर्ता",
        calculations: "गणनाएं की गईं",
        tools: "वित्तीय उपकरण",
        uptime: "अपटाइम"
      },
      team: {
        badge: "टीम",
        title: "हमारी टीम से मिलें",
        subtitle: "हम दो जुनूनी इंजीनियर हैं जो व्यक्तिगत वित्त को सभी के लिए सुलभ बनाने के लिए प्रतिबद्ध हैं।",
        roberto_ruiz: {
          name: "Roberto Ruiz Sánchez",
          role: "सह-संस्थापक & AI इंजीनियर",
          description: "आर्टिफिशियल इंटेलिजेंस इंजीनियर और डेटा साइंटिस्ट। औद्योगिक प्रक्रियाओं के लिए डीप लर्निंग मॉडल का विकास। NLP, संवादात्मक एजेंट और स्केलेबल क्लाउड इंफ्रास्ट्रक्चर में विशेषज्ञता।",
          skills: ["Python", "Deep Learning", "Data Science", "Machine Learning", "AWS", "Azure"]
        },
        roberto_otero: {
          name: "Roberto Otero Galán",
          role: "सह-संस्थापक & सॉफ्टवेयर इंजीनियर",
          description: "Java, Spring Boot और माइक्रोसर्विसेज आर्किटेक्चर में बैकएंड विकास का अनुभव रखने वाले सॉफ्टवेयर इंजीनियर। साइबर सुरक्षा, मशीन लर्निंग और बुद्धिमान प्रक्रिया स्वचालन के प्रति जुनूनी।",
          skills: ["Java", "Spring Boot", "Python", "AI", "Docker", "साइबर सुरक्षा"]
        }
      },
      mission: {
        badge: "हमारा मिशन",
        title: "वित्त को सभी के लिए सुलभ बनाना",
        description: "Finanzly में, हम मानते हैं कि हर किसी को शक्तिशाली वित्तीय उपकरणों तक पहुंच मिलनी चाहिए जो उन्हें बेहतर भविष्य बनाने में मदद कर सकें।",
        details: "आज के तेजी से विकसित हो रहे वित्तीय परिदृश्य में, हम समझते हैं कि व्यक्तिगत वित्त का प्रबंधन भारी पड़ सकता है।",
        highlight: {
          title: "हमारी प्रतिबद्धता",
          subtitle: "जो हमें हर दिन प्रेरित करता है"
        },
        point1: "आवश्यक वित्तीय उपकरणों तक मुफ्त पहुंच",
        point2: "गोपनीयता-प्रथम दृष्टिकोण, डेटा बिक्री नहीं",
        point3: "उपयोगकर्ता फीडबैक के आधार पर निरंतर सुधार"
      },
      values: {
        title: "हमारे मूल्य",
        subtitle: "वे सिद्धांत जो Finanzly में हम जो कुछ भी करते हैं उसका मार्गदर्शन करते हैं",
        transparency: {
          title: "पारदर्शिता",
          description: "हम स्पष्ट, ईमानदार संचार में विश्वास करते हैं। कोई छिपी फीस नहीं, कोई भ्रमित करने वाली शर्तें नहीं।"
        },
        simplicity: {
          title: "सरलता",
          description: "जटिल वित्तीय अवधारणाओं को सरल बनाया। हमारे उपकरण सहज और उपयोग में आसान होने के लिए डिज़ाइन किए गए हैं।"
        },
        accessibility: {
          title: "पहुंच",
          description: "वित्तीय उपकरण सभी के लिए उपलब्ध होने चाहिए, चाहे उनकी पृष्ठभूमि या विशेषज्ञता का स्तर कुछ भी हो।"
        },
        innovation: {
          title: "नवाचार",
          description: "हम आपको फिनटेक में नवीनतम लाने के लिए लगातार सीमाओं को पार करते हैं।"
        }
      },
      tools: {
        title: "हमारे वित्तीय उपकरण",
        description: "शक्तिशाली कैलकुलेटर जो आपको बेहतर वित्तीय निर्णय लेने में मदद करने के लिए डिज़ाइन किए गए हैं",
        comingSoon: "जल्द आ रहा है",
        available: "उपलब्ध",
        tryAssistant: "सहायक आज़माएं",
        viewAll: "सभी उपकरण देखें"
      },
      future: {
        badge: "नवाचार",
        title: "AI-संचालित वित्तीय योजना",
        description: "हम आपको व्यक्तिगत वित्तीय मार्गदर्शन प्रदान करने के लिए अत्याधुनिक कृत्रिम बुद्धिमत्ता का लाभ उठाते हैं। हमारा AI सहायक आपको जटिल वित्तीय निर्णयों को आत्मविश्वास के साथ नेविगेट करने में मदद करने के लिए डिज़ाइन किया गया है।",
        aiTitle: "AI वित्तीय सहायक",
        aiShort: "बेहतर वित्तीय निर्णयों के लिए आपका व्यक्तिगत AI सलाहकार",
        aiDescription: "हमारा AI-संचालित वित्तीय सहायक आपको बेहतर वित्तीय निर्णय लेने में मदद करता है, व्यक्तिगत सलाह प्रदान करता है और आपकी वित्तीय रणनीति को अनुकूलित करता है।",
        aiDetails: "हमारा AI सहायक आपके वित्तीय पैटर्न का विश्लेषण करने के लिए उन्नत मशीन लर्निंग एल्गोरिदम का लाभ उठाएगा।",
        feature1: "आपके लक्ष्यों के आधार पर व्यक्तिगत वित्तीय सलाह",
        feature2: "स्मार्ट खर्च विश्लेषण और सिफारिशें",
        feature3: "निवेश पोर्टफोलियो अनुकूलन सुझाव",
        feature4: "रीयल-टाइम मार्केट इनसाइट्स और अलर्ट"
      },
      cta: {
        title: "अपने वित्त पर नियंत्रण लेने के लिए तैयार हैं?",
        subtitle: "आज ही हमारे मुफ्त उपकरणों का उपयोग शुरू करें और बेहतर वित्तीय निर्णय लें।",
        button: "मुफ्त में शुरू करें"
      },
      skills: {
        python: 'Python',
        deepLearning: 'डीप लर्निंग',
        dataScience: 'डेटा साइंस',
        machineLearning: 'मशीन लर्निंग',
        aws: 'AWS',
        azure: 'Azure',
        java: 'Java',
        ai: 'AI',
        docker: 'Docker',
        cybersecurity: 'साइबर सुरक्षा'
      }
    }
  }
};
